import { useEffect, useState } from "react";
import "./Approval.css"
import { useUtils } from "../../../services/Utils";
import Person from "../../Person/Person";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const Approval = ({ content, handleRefresh }) => {
    const { callApi } = useUtils();
    const { accounts } = useMsal();

    const image = "data:image/jpeg;base64,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"

    const [outcome, setOutcome] = useState("");
    const [comment, setComment] = useState("");
    const [requireComment, setRequireComment] = useState(false);
    const [readOnly, setReadOnly] = useState(false);

    const [isSignoffRequestInProgress, setIsSignoffRequestInProgress] = useState(false);

    const signoffApproval = async () => {
        try {
            setIsSignoffRequestInProgress(true);
            await callApi({
                endpoint: "Approval/SignoffSignTicket",
                method: "POST",
                body: {
                    "SignTicketApprovalId": content.CurrentApprovalData.Id.toString(),
                    "ApproverEmail": accounts[0].username,
                    "Outcome": outcome,
                    "Comment": comment
                }
            });
        }
        catch (err) {
            console.log(err)
        }
        finally{
            setIsSignoffRequestInProgress(false);
        }
    }

    const handleSelectOutcome = (outcome) => {
        setOutcome(outcome);
        setComment("");
    }

    const handleSubmit = async () => {
        await signoffApproval();
        setOutcome("");
        setComment("");
        handleRefresh();
    }

    const getPlaceHolderText = () => {
        let button = content.CurrentApprovalData.SignTicketApprovalButtonList
            .find(x => x.Text === outcome);
        let placeHolderText = button.PlaceHolder;
        if (!placeHolderText)
            placeHolderText = "Please input comment"
        return placeHolderText;
    }

    // When user click outcome button, check if comment is mandatory and scorll down to bottom
    useEffect(() => {
        if (outcome !== "") {
            setRequireComment(content.CurrentApprovalData.SignTicketApprovalButtonList
                .find(x => x.Text === outcome).RequireComment);
        }
        else {
            setRequireComment(false);
        }

        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
        });
    }, [outcome])


    return (
        <div className="card container">
            <div id="cardStatus">
                <h3>{content.Status}</h3>
            </div>

            <div id="cardTitle" className="cardElement">
                <h4>{content.FormData.Title}</h4>
            </div>
            <div id="cardAuthor" className="cardElement">
                <div id="cardCreatedByAvatar">
                    <img src={image} alt="Avatar" width="64" height="64" />
                </div>
                <div>
                    <Person id="cardCreatedByName" email={content.FormData.CreatedByEmail} />
                    <div id="cardCreatedTime">Created on {(new Date(content.FormData.CreateTime)).toLocaleString({ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })}</div>
                </div>
            </div>
            <div id="cardDetail" className="cardElement"><pre>{content.FormData.Details}</pre></div>
            <div id="cardContentTable" className="cardElement">
                <table>
                    <tbody>
                        {content.FormData.SignTicketContentTableList.map((item, index) => (
                            <tr key={index}>
                                <td><div>{item.FieldName}</div></td>
                                <td><div>{item.FieldValue}</div></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {
                content.FormData.SignTicketAttachmentLinkList.length !== 0 &&
                <>
                    <hr />
                    <div id="cardAttachment" className="cardElement">
                        <h4>Attachments</h4>
                        <ul>
                            {content.FormData.SignTicketAttachmentLinkList.map((item, index) => (
                                <li key={index}>
                                    <a href={item.Url} target="_blank">{item.Description}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </>
            }
            {
                content.FormData.SignTicketApproval.filter(x => x.Result !== null).length !== 0 &&
                <>
                    <hr />
                    <div id="cardHistory" className="cardElement">
                        <h4>Approval History</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th>Approver</th>
                                    <th>Outcome</th>
                                    <th>Comment</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {content.FormData.SignTicketApproval
                                    .filter(x => x.Result !== null)
                                    .sort((a, b) => new Date(a.Result.CreateTime) - new Date(b.Result.CreateTime))
                                    .map((item, index) => (
                                        <tr key={index}>
                                            <td><Person email={item.Result.ApproverEmail} /></td>
                                            <td>{item.Result.Outcome}</td>
                                            <td>{item.Result.Comment}</td>
                                            <td>{(new Date(item.Result.CreateTime + " UTC")).toLocaleString()}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </>
            }
            {
                !readOnly &&
                <div id="cardButton" className="cardElement">
                    {content.CurrentApprovalData.SignTicketApprovalButtonList.map((item, index) => (
                        <Button
                            variant="contained"
                            size="large"
                            key={index}
                            onClick={() => handleSelectOutcome(item.Text)}
                            disabled={(outcome !== "" && outcome !== item.Text) || isSignoffRequestInProgress}
                        >
                            {item.Text}
                        </Button>
                    ))}
                </div>
            }
            {
                outcome !== "" && !readOnly &&
                <div id="cardOutcome">
                    <div id="cardOutcomeHeader">
                        <a id="cardOutcomeText">{outcome}</a>
                        <a id="cardCloseOutcomeButton" className="close" onClick={() => handleSelectOutcome("")}><CloseIcon /></a>
                    </div>
                    <textarea
                        autoFocus
                        rows="4"
                        placeholder={getPlaceHolderText() + (requireComment ? "*" : "")}
                        onChange={(e) => setComment(e.target.value)}
                        value={comment}
                    ></textarea>
                    <div className="submitButton">
                        <Button
                            variant="contained"
                            size="large"
                            disabled={(requireComment && !comment) || isSignoffRequestInProgress}
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            }
        </div>
    )
}

export default Approval;